// This file is auto-generated by scripts/generate-version.js
// Do not edit manually

export interface VersionInfo {
  full: string;
  tag: string | null;
  hash: string | null;
  isDirty: boolean;
  timestamp: string;
}

export const VERSION: VersionInfo = {
  full: "unknown",
  tag: null,
  hash: "unknown",
  isDirty: false,
  timestamp: "2026-11-05T08:46:04.071Z",
};
